import { includes } from "lodash"
import PropTypes from "prop-types"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"

import { t, tError } from "../../i18next"
import { fetchLgDetail } from "../home/redux/fetchLgDetail"

class WithLgDetail extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    children: PropTypes.node,
    lgDetailError: PropTypes.shape({
      graphqlErrors: PropTypes.arrayOf(PropTypes.object.isRequired),
      networkError: PropTypes.object,
    }),
    lgDetailLoaded: PropTypes.bool,
    lgDetailLoading: PropTypes.bool,
    propertyRef: PropTypes.string.isRequired,
  }

  componentDidMount() {
    const { lgDetailError, lgDetailLoaded, lgDetailLoading, propertyRef } = this.props
    const { fetchLgDetail } = this.props.actions

    if (!lgDetailLoaded && !lgDetailLoading && !lgDetailError) {
      fetchLgDetail(null, [propertyRef])
    }
  }

  render() {
    const { children, lgDetailError, lgDetailLoaded, lgDetailLoading } = this.props

    if (lgDetailLoaded) {
      return children
    } else if (lgDetailLoading) {
      return this.renderLoading()
    } else if (lgDetailError) {
      return this.renderError(lgDetailError)
    } else {
      return this.renderLoading() // We issued fetchLgDetail during mount
    }
  }

  renderError({ graphqlErrors, networkError }) {
    return (
      <div className="lg-detail-missing-message">
        {networkError && <div>{tError("common", { code: "network_error" })}</div>}
        {graphqlErrors && <div>{tError("damage-case", graphqlErrors)}</div>}
      </div>
    )
  }

  renderLoading() {
    return <div className="lg-detail-missing-message">{t("home.fetchingLho")}</div>
  }
}

/* istanbul ignore next */
function mapStateToProps(state, ownProps) {
  const { propertyRef } = ownProps
  const { lhoData, fetchLgDetailPending, fetchLgDetailError } = state.home || {}
  const properties = lhoData && lhoData.properties
  const property = properties && properties.find(p => p.reference === propertyRef)
  const lgDetailLoaded = Boolean(property) && property.hasOwnProperty("houses")
  const lgDetailLoading = Boolean(fetchLgDetailPending) && includes(fetchLgDetailPending, propertyRef)
  const lgDetailError = fetchLgDetailError && fetchLgDetailError[propertyRef]

  return {
    lgDetailError,
    lgDetailLoaded,
    lgDetailLoading,
  }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ fetchLgDetail }, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithLgDetail)



// WEBPACK FOOTER //
// ./src/features/lho-explorer/WithLgDetail.js